module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "favicon-32x32.664179bb.png";